module.exports = __webpack_public_path__ + "img/pc3.39725f1b.png";